import { mapState } from 'vuex';
import plantsClient from '@/core/services/plants';
import BadgeItem from './BadgeItem/BadgeItem.vue';
import { Options, Vue } from 'vue-class-component';
import {
  BadgeDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DialogAddBadge from './DialogAddBadge/DialogAddBadge.vue';

enum BadgeType {
  resident = 'resident',
  guest = 'guest',
}

@Options({
  name: 'EntrancePlantBadges',
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {
    BadgeItem,
    DialogAddBadge,
  },
  emits: ['update-list'],
})
export default class EntrancePlantBadges extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  badges: BadgeDTO[] = [];

  isVisibleAddBadge = false;
  isGuestBadgeDialog = false;
  isGuestBadgeDisabled = false;
  BadgeType = BadgeType;

  async mounted() {
    await this.fetchBadges();
  }

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  async fetchBadges() {
    this.badges = await plantsClient.badgeAll(
      this.currentEntrancePlant.desktopId as number
    );
  }

  get hasBadges() {
    if (this.badges) {
      return this.badges.length > 0;
    }
    return false;
  }

  get hasEligibleGuests() {
    const today = Date.parse(new Date().toDateString());

    const hasValidGuestForBadge = this.currentEntrancePlant.gateGuests?.some(
      (guest) => {
        const guestNotExpired =
          guest.durationUntil === undefined ||
          (guest.durationUntil && guest.durationUntil.valueOf() >= today);
        const guestNotHasBadge = guest.badgeCode === '' || !guest.badgeCode;
        if (guest.isRecurrent && guestNotExpired && guestNotHasBadge) {
          return true;
        }
      }
    );
    return hasValidGuestForBadge;
  }

  handleAddBadge(type: BadgeType) {
    if (type !== undefined) {
      this.isGuestBadgeDialog = type === BadgeType.guest;
    }
    this.isVisibleAddBadge = !this.isVisibleAddBadge;
    if (!this.isVisibleAddBadge) {
      this.$emit('update-list');
    }
  }

  async handleDeleteBadge(badge: BadgeDTO) {
    this.$store.dispatch(SET_APP_LOADING, true);
    try {
      await plantsClient.badgeDELETE(
        this.currentEntrancePlant.desktopId as number,
        badge.badgeCode
      );

      this.$emit('update-list');
      this.fetchBadges();
      setTimeout(() => {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('AppResourceEP.BadgeRemoved'),
          closable: false,
          life: 3000,
        });
      }, 1500);
    } catch {
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
